export class HbOrderAcceptanceRequest {
    id:number;
    custPo: string;
    style: number;
    itemNo: string;
    buyer: string;
    exitFactoryDate:string;
    
}